/* NERDIS · el motor de dibujo del preview.
 *
 * TIENE QUE DAR LO MISMO QUE componer.py. Si el preview y la imprenta se separan,
 * el cliente ve una cosa y recibe otra, y ese es el único fallo de este proyecto
 * que no tiene arreglo a posteriori. Cada función dice a cuál del motor equivale.
 *
 * DESDE LA F3 (sep 2026) DIBUJA CARAS, VARIAS, Y TODAS LAS PLANTILLAS SIN CUERPO:
 *   A-retrato, D-duo, J-diagonal   caras alternando con iconos
 *   F-nombre-y-cara                caras, y el nombre en uno de cada dos huecos
 *   G-bandas                       bandas de color a lo ancho, sin franja
 *   K-medalla                      un disco blanco detrás de cada cara
 *   C-mash                         las caras SON el fondo: sin filete, cada una
 *                                  a su escala y su giro (vienen en la retícula)
 *   E-nombre                       la "cara" es el texto
 * B-personaje e I-gran llevan un cuerpo dibujado debajo de la cabeza y quedan
 * fuera hasta que exista ese arte por producto.
 *
 * Tres cosas que hay que saber para tocarlo:
 *
 * 1. Se copia EL CÓDIGO del motor, no su intención. Sin cuerpo, componer.py
 *    escala la cara con encajar() liso más realce_cara(); la detección de piel
 *    SOLO entra cuando hay un cuerpo debajo. Y el mash ni realce lleva.
 *
 * 2. El desorden es un hash, no un random. sacude(i, j, k) tiene que dar el
 *    mismo número aquí y en Python, y Python opera con enteros sin límite:
 *    k * 83492791 se pasa de 32 bits, y con el ^ de JS -que trunca a 32- salía
 *    otro caos. Por eso va en BigInt.
 *
 * 3. Con varias caras, cada FILA es de una persona -su cara grande y, con eco,
 *    su eco pequeño y en espejo al lado- y las filas alternan: de frente, el
 *    zigzag va A B A B. Igual que componer.persona(); la nota larga está allí.
 *    Carlos, 30 sep 2026: «como en el vídeo: caras pequeñas y grandes, pero
 *    bien alternas, y giradas, en plan efecto espejo». Del 25 al 30 sep fue un
 *    tablero de ajedrez que, sin eco, con dos fotos enseñaba UNA persona, y
 *    con eco dejaba el calcetín en cuadrícula recta.
 */
(function () {
  'use strict';
  window.NERDIS = window.NERDIS || {};

  var HUECO_FRANJA_MM = 2.0;   // franja_deportiva() deja 2 mm entre bandas
  var ultimo = null;           // para repintar cuando llegue la tipografía

  /* SAL por papel, como en componer.py: la cara y el elemento de la MISMA fila
     y columna no pueden moverse igual. */
  var SAL = { cara: 11, cuerpo: 11, elemento: 21, lettering: 31, relleno: 41 };

  /* plantillas.NEGRO: donde el hilo es negro y una frase partida no se lee. */
  var NEGRO = [[222.0, 292.0], [432.0, 485.0]];
  var CANA_FIN = 220.0;        // plantillas.CANA[1]: donde acaba la zona recta
  var FONDO_MASH = '#E9C7B4';  // tono piel, por si asoma entre caras

  /* EL GORRO PUESTO (f17, 8 oct 2026). Gemelo de `_DISEÑOS v3/gorro.py`: las
     cuatro funciones de cuentas -colocacionGorro, geometriaGorro, cajaEfectiva,
     desplazamientoGorro- dan lo mismo que las de Python y lo coteja
     f11-caras/paridad/cotejar.py. Las medidas de los dibujos salen de
     Brand/Elementos v3/gorros/gorros.json (gorro.py los endereza y los mide);
     si se rehacen, se copian aquí. La colocación la calcula el personalizador
     UNA vez, con los 68 puntos que devuelve el recorte, y viaja en el pedido. */
  var GORRO = {
    ANCHO: 1.05, SOBRE_CEJA: 0.12, CUENTA: 0.5, UMBRAL: 8,
    medidas: {
      papanoel: { ancho: 582, alto: 398, x0: 14, x1: 418, y: 368.0 },
      elfo:     { ancho: 584, alto: 463, x0: 9,  x1: 430, y: 432.44 },
      // las astas van DETRAS de la cabeza: asoman por arriba (9 oct 2026)
      reno:     { ancho: 860, alto: 482, x0: 116.24, x1: 743.76, y: 524.81, detras: true }
    }
  };

  /* gorro.colocacion(): de los 68 puntos (px de la cabeza) a [ax, ay, an, g]. */
  function colocacionGorro(P, caja) {
    function media(a, b, k) { var s = 0; for (var i = a; i < b; i++) { s += P[i][k]; } return s / (b - a); }
    var g = Math.atan2(media(42, 48, 1) - media(36, 42, 1), media(42, 48, 0) - media(36, 42, 0));
    var cx = media(17, 27, 0), cy = media(17, 27, 1);
    var co = Math.cos(-g), si = Math.sin(-g);
    var R = P.map(function (p) {
      var x = p[0] - cx, y = p[1] - cy;
      return [cx + x * co - y * si, cy + x * si + y * co];
    });
    var ancho = Math.abs(R[16][0] - R[0][0]);
    var ceja = Infinity;
    for (var i = 17; i < 27; i++) { if (R[i][1] < ceja) { ceja = R[i][1]; } }
    var ax = (R[0][0] + R[16][0]) / 2, ay = ceja - GORRO.SOBRE_CEJA * ancho;
    co = Math.cos(g); si = Math.sin(g);
    var x = ax - cx, y = ay - cy;
    ax = cx + x * co - y * si; ay = cy + x * si + y * co;
    var w = caja[2] - caja[0], h = caja[3] - caja[1];
    return [(ax - caja[0]) / w, (ay - caja[1]) / h, GORRO.ANCHO * ancho / w, g];
  }

  /* gorro.geometria(): la matriz dibujo -> cabeza y la caja de los dos juntos. */
  function geometriaGorro(W, H, caja, geo, med) {
    var hw = caja[2] - caja[0], hh = caja[3] - caja[1];
    var Ax = caja[0] + geo[0] * hw, Ay = caja[1] + geo[1] * hh;
    var s = geo[2] * hw / (med.x1 - med.x0);
    var co = Math.cos(geo[3]), si = Math.sin(geo[3]);
    var a = s * co, b = -s * si, c = s * si, d = s * co;
    var bx = (med.x0 + med.x1) / 2, by = med.y;
    var tx = Ax - (a * bx + b * by), ty = Ay - (c * bx + d * by);
    var xs = [0, W], ys = [0, H];
    [[0, 0], [med.ancho, 0], [0, med.alto], [med.ancho, med.alto]].forEach(function (p) {
      xs.push(a * p[0] + b * p[1] + tx); ys.push(c * p[0] + d * p[1] + ty);
    });
    return { m: [a, b, c, d, tx, ty],
             u: [Math.min.apply(null, xs), Math.min.apply(null, ys), Math.max.apply(null, xs), Math.max.apply(null, ys)] };
  }

  /* gorro.caja_efectiva(): la cabeza crecida `cuenta` de lo que añade el gorro. */
  function cajaEfectiva(W, H, u, cuenta) {
    if (cuenta === undefined) { cuenta = GORRO.CUENTA; }
    return [cuenta * u[0], cuenta * u[1], W + cuenta * (u[2] - W), H + cuenta * (u[3] - H)];
  }

  /* gorro.desplazamiento(): cuánto se corre la pieza, ya girada como tesela(). */
  function desplazamientoGorro(u, ef, f, giro) {
    var ox = ((u[0] + u[2]) - (ef[0] + ef[2])) / 2 * f;
    var oy = ((u[1] + u[3]) - (ef[1] + ef[3])) / 2 * f;
    var t = giro * Math.PI / 180;
    return [ox * Math.cos(t) + oy * Math.sin(t), -ox * Math.sin(t) + oy * Math.cos(t)];
  }

  /* gorro.contorno(): la caja de la cabeza por su alfa (> 8, como sinAire). */
  function contornoAlfa(im) {
    var c = document.createElement('canvas');
    c.width = im.width; c.height = im.height;
    var g = c.getContext('2d');
    g.drawImage(im, 0, 0);
    var d = g.getImageData(0, 0, c.width, c.height).data;
    var x0 = c.width, y0 = c.height, x1 = -1, y1 = -1;
    for (var y = 0; y < c.height; y++) {
      for (var x = 0; x < c.width; x++) {
        if (d[(y * c.width + x) * 4 + 3] > GORRO.UMBRAL) {
          if (x < x0) { x0 = x; } if (x > x1) { x1 = x; }
          if (y < y0) { y0 = y; } if (y > y1) { y1 = y; }
        }
      }
    }
    return x1 < 0 ? [0, 0, c.width, c.height] : [x0, y0, x1 + 1, y1 + 1];
  }

  /* gorro.poner(): la cabeza con el gorro puesto, en un lienzo que abarca los
     dos, y su caja en píxeles de la cabeza. Se guarda en la propia cabeza:
     cada repintado no vuelve a medir el alfa. `gz` = { img, tipo, geo }. */
  function ponerGorro(cab, gz) {
    var clave = gz.tipo + ':' + gz.geo.join(',');
    if (cab._gorro && cab._gorro.clave === clave) { return cab._gorro; }
    var med = GORRO.medidas[gz.tipo];
    var caja = cab._contorno || (cab._contorno = contornoAlfa(cab));
    var geo = geometriaGorro(cab.width, cab.height, caja, gz.geo, med);
    var x0 = Math.floor(geo.u[0]), y0 = Math.floor(geo.u[1]);
    var Wc = Math.ceil(geo.u[2]) - x0, Hc = Math.ceil(geo.u[3]) - y0;
    var o = document.createElement('canvas');
    o.width = Wc; o.height = Hc;
    var g = o.getContext('2d');
    g.imageSmoothingQuality = 'high';
    if (!med.detras) { g.drawImage(cab, -x0, -y0); }
    var m = geo.m;
    g.setTransform(m[0], m[2], m[1], m[3], m[4] - x0, m[5] - y0);
    g.drawImage(gz.img, 0, 0, med.ancho, med.alto);
    g.setTransform(1, 0, 0, 1, 0, 0);
    // las astas, debajo: la cabeza tapa su base y parece que le salen
    if (med.detras) { g.drawImage(cab, -x0, -y0); }
    cab._gorro = { clave: clave, img: o, u: [x0, y0, x0 + Wc, y0 + Hc] };
    return cab._gorro;
  }

  function familiaCss(f) { return '"' + (f || 'Titan One') + '", system-ui, sans-serif'; }

  /* plantillas.sacude(): desorden REPETIBLE. Ver la nota 2 de la cabecera. */
  function sacude(i, j, k) {
    var v = (BigInt(i) * 73856093n) ^ (BigInt(j) * 19349663n) ^ (BigInt(k) * 83492791n);
    return Number((v >> 5n) % 1000n) / 1000.0;
  }

  /* componer.sacudida(): [dx mm, dy mm, giro grados] para una ranura y un papel. */
  function sacudida(cfg, r, papel) {
    var j = (cfg.jitter || {})[papel] || [0, 0];
    var d = j[0] || 0, g = j[1] || 0;
    if (!d && !g) { return [0, 0, 0]; }
    var s = SAL[papel] || 11, col = r[3] || 0, fila = r[4] || 0;
    /* GIRO ALTERNO: misma regla que componer.py. Los papeles de `giro_alterno`
       toman el angulo entero, con el signo alternando por (col + fila). Ver la
       nota larga en componer.sacudida(). */
    var alt = cfg.giro_alterno || [];
    /* Por FILA desde el 25 sep 2026, y el elemento al revés que la cara de su
       fila: por (col + fila) todo el frente giraba hacia el mismo lado. */
    var giro = (alt.indexOf(papel) >= 0)
      ? (((fila + (papel === 'elemento' ? 1 : 0)) % 2 === 0) ? g : -g)
      : (sacude(col, fila, s + 2) - 0.5) * 2 * g;
    return [(sacude(col, fila, s) - 0.5) * 2 * d,
            (sacude(col, fila, s + 1) - 0.5) * 2 * d,
            giro];
  }

  /* componer.persona(): qué cara va en esta ranura, de 0 a n-1. La de su
     FILA, para las grandes y para los ecos. Ver la nota 3 de la cabecera. */
  function persona(r, n) { return (r[4] || 0) % n; }

  /* componer.ECO_PEQUENO: el eco va al 86% de la caja del icono, con una cara
     o con varias. Es lo que hace que se lea el tresbolillo. */
  var ECO_PEQUENO = 0.86;

  /* LA HUELLA VA TRAMADA, NO DE PEGATINA. generar.TEXTURA dice qué pieza de
     cada juego es trama, por NÚMERO DE FICHERO; aquí va traducido a su marco en
     la tira, que sale en el orden de compilar_iconos.JUEGOS. mascota es [1, 2]
     con la huella en la 01, así que su marco es el 0 y el 1 es el CORAZÓN.
     cotejar.py comprueba que esta tabla y la de Python dicen lo mismo. */
  var TRAMA = { perro: 1, gato: 1, conejo: 1, mascota: 0 };
  var TRAMA_ESCALA = 0.55;   // generar.OPACIDAD_TRAMA: es TAMAÑO, no opacidad
  var TRAMA_K = 0.22;        // generar.trama(): el fondo un 22% hacia el texto

  /* round() de Python: el 0,5 va al PAR. Math.round lo sube siempre. */
  function redondeoPy(v) {
    var f = Math.floor(v), d = v - f;
    if (d > 0.5) { return f + 1; }
    if (d < 0.5) { return f; }
    return (f % 2 === 0) ? f : f + 1;
  }

  /* generar.trama(): el tono de la huella sale de los DOS colores del pedido. */
  function colorTrama(fondo, texto) {
    var f = String(fondo || '').replace('#', ''), t = String(texto || '').replace('#', '');
    if (f.length !== 6 || t.length !== 6) { return fondo; }
    var out = '#';
    for (var i = 0; i < 6; i += 2) {
      var v = redondeoPy(parseInt(f.substr(i, 2), 16) * (1 - TRAMA_K) +
                         parseInt(t.substr(i, 2), 16) * TRAMA_K);
      out += (v < 16 ? '0' : '') + v.toString(16).toUpperCase();
    }
    return out;
  }

  /* componer.tenir(): la pieza aplanada a UN color, conservando su alfa. */
  function tenir(src, color) {
    var c = document.createElement('canvas');
    c.width = src.width; c.height = src.height;
    var g = c.getContext('2d');
    g.drawImage(src, 0, 0);
    g.globalCompositeOperation = 'source-in';
    g.fillStyle = color;
    g.fillRect(0, 0, c.width, c.height);
    return c;
  }

  /* El juego de iconos sale del nombre de la tira que se ha cargado de verdad
     (nerdis-elementos-perro.webp). Si la de la ficha falló y entró la de
     cumpleaños, no hay trama, que es lo correcto: se pinta lo que se ve. */
  function juegoDe(o) {
    if (o.iconos) { return o.iconos; }
    var m = /nerdis-elementos-([a-z0-9-]+)\.webp/.exec((o.sprite && o.sprite.src) || '');
    return m ? m[1] : null;
  }

  /* plantillas.pisa_negro(): si una pieza centrada en y pisa talón o puntera. */
  /* El TALÓN solo es negro por detrás (la bolsa): si se pasa x y la pieza cae
     en el frente, no cuenta. La puntera sí, entera. Carlos, 25 sep 2026. */
  /* puntera === false: no cuenta la puntera. El nombre de «Tu cara y tu
     nombre» va aunque se corte (Carlos: «da igual que se corte»). */
  function pisaNegro(y, alto, x, puntera) {
    var a = y - alto / 2 - 4, b = y + alto / 2 + 4;
    for (var i = 0; i < NEGRO.length; i++) {
      if (i === 0 && x !== undefined && deFrente(x, 257.7)) { continue; }
      if (i === 1 && puntera === false) { continue; }
      if (a < NEGRO[i][1] && b > NEGRO[i][0]) { return true; }
    }
    return false;
  }

  /* LAS RANURAS DE ICONO EN ORDEN DE LECTURA, Y CUÁLES LLEVAN LA FRASE.
     Copiado de plantillas.reparto_elementos(), no reinventado: si aquí cae en
     otro sitio que en la lámina, el cliente ve una cosa y recibe otra.

     De un calcetín puesto solo se ve la mitad del contorno (las dos secciones
     centrales, nerdis-forma.js). Las dos columnas de la retícula alternan cara
     de delante y de atrás, así que repartir por índice de ranura enseñaba de
     frente solo los iconos pares -0, 2, 4, 6, 0, 2- y la frase donde le tocaba
     por número. Carlos, 8 sep 2026: arriba lo más representativo del tema, la
     frase justo debajo, y sin repetir nada en lo que se ve.

       orden      primero el FRENTE de arriba abajo, luego atrás de arriba abajo
       frase      UNA y solo DELANTE, en la segunda ranura libre (la primera es
                  del icono que identifica el tema); nunca sobre el negro
       iconos     por orden del juego, contando solo las ranuras que llevan icono

     OJO CON LA ALTURA: la caja de la frase se mide con lettering_mm y con 0 si
     la plantilla no lo declara, igual que componer.py desde el principio. */
  function deFrente(x, ancho) { return x >= ancho / 4 && x < ancho * 3 / 4; }

  function ordenElementos(cfg, ancho) {
    var lista = [], i;
    for (i = 0; i < cfg.r.length; i++) { if (cfg.r[i][0] === 'e') { lista.push(cfg.r[i]); } }
    lista.sort(function (a, b) {
      var fa = deFrente(a[1], ancho) ? 0 : 1, fb = deFrente(b[1], ancho) ? 0 : 1;
      if (fa !== fb) { return fa - fb; }
      if (a[2] !== b[2]) { return a[2] - b[2]; }
      return a[1] - b[1];
    });
    var altoFrase = cfg.lettering_mm ? cfg.lettering_mm[1] : 0;
    var conFrase = {};
    /* SOLO DELANTE desde el 25 sep 2026 (Carlos: «quita el trasero»). */
    [true].forEach(function (frente) {
      var libres = [];
      for (i = 0; i < lista.length; i++) {
        if (deFrente(lista[i][1], ancho) === frente && !pisaNegro(lista[i][2], altoFrase, lista[i][1])) { libres.push(i); }
      }
      if (libres.length > 1) { conFrase[libres[1]] = true; }
    });
    return { lista: lista, conFrase: conFrase };
  }

  /* texto_pieza(): mayúsculas, cuerpo 200 y contorno negro propio del 8,5%.
     Sin ese contorno, un nombre claro al que luego se le pone el filete blanco
     se convierte en una mancha: pasó con LUCÍA y con MARIO.
     La FAMILIA la manda la plantilla: Anton donde el texto va estrecho, que da
     un 60% más de alto sin ocupar más ancho. */
  function piezaTexto(txt, color, familia) {
    var CUERPO = 200, BORDE = Math.round(CUERPO * 0.085), M = BORDE + 12;
    var fuente = CUERPO + 'px ' + familiaCss(familia);
    var m = document.createElement('canvas').getContext('2d');
    m.font = fuente;
    var t = String(txt).toUpperCase();
    var med = m.measureText(t);
    /* EL MARCO, COMO EL DE PIL (25 sep 2026). textbbox() con stroke_width
       devuelve el avance y la tinta MÁS el borde a cada lado, y a eso se le
       suma el margen: ancho = avance + 2·BORDE + 2·M, alto = tinta + 2·BORDE +
       2·M. Aquí faltaban los 2·BORDE, y la pieza salía con otra proporción:
       hasta un 11 % distinta de la que se imprime.
       Y un descenso de 0 es un dato, no un hueco: con `|| CUERPO * 0.2` los
       nombres sin letras que bajen (ANA) ganaban 40 px de aire por abajo. */
    var asc = med.actualBoundingBoxAscent, des = med.actualBoundingBoxDescent;
    if (typeof asc !== 'number') { asc = CUERPO * 0.8; }
    if (typeof des !== 'number') { des = CUERPO * 0.2; }
    var c = document.createElement('canvas');
    c.width  = Math.ceil(med.width) + 2 * BORDE + 2 * M;
    c.height = Math.ceil(asc + des) + 2 * BORDE + 2 * M;
    var x = c.getContext('2d');
    x.font = fuente; x.textBaseline = 'alphabetic';
    x.lineJoin = 'round';
    x.lineWidth = BORDE * 2;          // canvas centra el trazo; PIL lo saca hacia fuera
    x.strokeStyle = '#1A1A1A';
    x.strokeText(t, M + BORDE, M + BORDE + asc);
    x.fillStyle = color;
    x.fillText(t, M + BORDE, M + BORDE + asc);
    return c;
  }

  /* contorno(): se dilata el ALFA, no se engorda el dibujo. */
  function conFilete(src, mm, pxmm) {
    if (!mm) { return src; }
    var r = Math.max(1, mm * pxmm);
    var sil = document.createElement('canvas');
    sil.width = src.width; sil.height = src.height;
    var s = sil.getContext('2d');
    s.drawImage(src, 0, 0);
    s.globalCompositeOperation = 'source-in';
    s.fillStyle = '#FFFFFF';
    s.fillRect(0, 0, sil.width, sil.height);

    var o = document.createElement('canvas');
    o.width = src.width + 2 * r; o.height = src.height + 2 * r;
    var c = o.getContext('2d');
    for (var a = 0; a < 20; a++) {
      var th = a / 20 * Math.PI * 2;
      c.drawImage(sil, r + Math.cos(th) * r, r + Math.sin(th) * r);
    }
    c.drawImage(src, r, r);
    return o;
  }

  /* vestir(): ESCALAR PRIMERO Y FILETEAR DESPUÉS.
     Al revés el grosor del filete depende de lo grande que viniera el PNG y sale
     distinto en el preview y en la imprenta. Es un fallo silencioso: no se ve
     mirando el código, se ve midiendo el resultado. */
  function vestir(src, anMM, alMM, fileteMM, esc) {
    var f = Math.min(anMM * esc / src.width, alMM * esc / src.height);
    var c = document.createElement('canvas');
    c.width  = Math.max(1, Math.round(src.width  * f));
    c.height = Math.max(1, Math.round(src.height * f));
    var g = c.getContext('2d');
    g.imageSmoothingQuality = 'high';
    g.drawImage(src, 0, 0, c.width, c.height);
    return conFilete(c, fileteMM, esc);
  }

  /* realce_cara(): cuánto agrandar una cabeza para que su CARA mida lo mismo que
     las demás. Se mide el ancho a la altura de la mandíbula -el tramo del 62% al
     82% del alto, donde ya no hay pelo a los lados- contra el ancho máximo. Más
     pelo, más realce, con tope 1,15 porque lo que gana la cara lo pierde la
     holgura con el vecino. Sobre el alfa, umbral 40, igual que en Python. */
  function realceCara(im, tope) {
    tope = tope || 1.15;
    var w = im.width, h = im.height;
    if (!w || !h) { return 1.0; }
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var g = c.getContext('2d');
    g.drawImage(im, 0, 0);
    var d = g.getImageData(0, 0, w, h).data;
    var filas = new Array(h), total = 0, alguna = false;
    for (var y = 0; y < h; y++) {
      var n = 0, base = y * w * 4;
      for (var x = 0; x < w; x++) { if (d[base + x * 4 + 3] > 40) { n++; } }
      filas[y] = n;
      if (n > total) { total = n; }
      if (n) { alguna = true; }
    }
    if (!alguna) { return 1.0; }
    var y0 = Math.floor(h * 0.62), y1 = Math.floor(h * 0.82), banda = [];
    for (var yy = y0; yy < y1; yy++) { if (filas[yy]) { banda.push(filas[yy]); } }
    if (!banda.length) { return 1.0; }
    banda.sort(function (a, b) { return a - b; });
    var m = banda.length, mand = (m % 2) ? banda[(m - 1) / 2]
                                        : (banda[m / 2 - 1] + banda[m / 2]) / 2;
    if (mand <= 0) { return 1.0; }
    return Math.min(tope, Math.max(1.0, (Math.max(1, total) / mand) / 1.55));
  }

  /* pegar(): centrado en (cx, cy) mm, GIRADO, y duplicado si cruza la costura.
     PIL gira en sentido antihorario con ángulo positivo; canvas al revés. */
  function tesela(g, im, xmm, ymm, esc, ancho, giro) {
    for (var d = -1; d <= 1; d++) {
      var cx = (xmm + d * ancho) * esc, cy = ymm * esc;
      if (giro) {
        g.save();
        g.translate(cx, cy);
        g.rotate(-giro * Math.PI / 180);
        g.drawImage(im, -im.width / 2, -im.height / 2);
        g.restore();
      } else {
        g.drawImage(im, cx - im.width / 2, cy - im.height / 2);
      }
    }
  }

  /* espejo(): la imagen reflejada de izquierda a derecha (Image.FLIP_LEFT_RIGHT). */
  function espejo(im) {
    var c = document.createElement('canvas');
    c.width = im.width; c.height = im.height;
    var g = c.getContext('2d');
    g.translate(im.width, 0);
    g.scale(-1, 1);
    g.drawImage(im, 0, 0);
    return c;
  }

  function marco(sp, i) {
    var lado = sp.height;
    var c = document.createElement('canvas');
    c.width = lado; c.height = lado;
    c.getContext('2d').drawImage(sp, i * lado, 0, lado, lado, 0, 0, lado, lado);
    return c;
  }

  /* LOS FONDOS DE NAVIDAD (f17, 9 oct 2026): componer._luces() y _nieve(),
     con los mismos numeros y en el mismo orden. Pillow pinta el contorno de
     una elipse o de un rectangulo POR DENTRO de su caja y el canvas lo centra
     en el borde: aqui el trazo va metido medio grosor para que caiga igual. */
  var LUCES = { paso: 96.0, ondas: 8, caida: 7.0, bombillas: [0.30, 0.72] };
  var NIEVE = { copos: 9, alto: 80.0 };
  var COPIAS = [0, -1, 1];   // el orden de pegar(): x, x - ancho, x + ancho

  function elipseFondo(g, cx, cy, rx, ry, esc, relleno, borde, grosor) {
    g.beginPath();
    g.ellipse(cx * esc, cy * esc, rx * esc, ry * esc, 0, 0, Math.PI * 2);
    g.fillStyle = relleno;
    g.fill();
    if (borde) {
      g.beginPath();
      g.ellipse(cx * esc, cy * esc, (rx - grosor / 2) * esc, (ry - grosor / 2) * esc, 0, 0, Math.PI * 2);
      g.strokeStyle = borde;
      g.lineWidth = grosor * esc;
      g.stroke();
    }
  }

  function bombilla(g, x, y, color, esc) {
    g.fillStyle = '#3E5B47';
    g.fillRect((x - 1.3) * esc, y * esc, 2.6 * esc, 2.6 * esc);
    g.strokeStyle = '#111111';
    g.lineWidth = 0.45 * esc;
    g.strokeRect((x - 1.3 + 0.225) * esc, (y + 0.225) * esc, 2.15 * esc, 2.15 * esc);
    var cy = y + 6.8;
    elipseFondo(g, x, cy, 3.0, 4.4, esc, color, '#111111', 0.55);
    elipseFondo(g, x - 1.05, cy - 1.6, 0.55, 1.0, esc, 'rgba(255,255,255,0.784)');
  }

  /* La guirnalda en helice: una vuelta al calcetin cada LUCES.paso mm, en
     ondas que cuelgan, y dos bombillas por onda. colores: fondo, cable, bombillas. */
  function lucesFondo(g, colores, esc, ancho, alto, y0) {
    var cable = colores[1], bombillas = colores.slice(2);
    if (!bombillas.length) { bombillas = ['#F6C343']; }
    var yIni = y0 + 8.0, onda = ancho / LUCES.ondas, baja = LUCES.paso / LUCES.ondas, k = 0;
    function punto(xa, ya, t) { return [xa + t * onda, ya + t * baja + LUCES.caida * 4 * t * (1 - t)]; }
    for (var v = 0; yIni + v * LUCES.paso < alto + LUCES.paso; v++) {
      for (var s = 0; s < LUCES.ondas; s++) {
        var xa = s * onda, ya = yIni + v * LUCES.paso + s * baja;
        g.strokeStyle = cable;
        g.lineWidth = 1.0 * esc;
        g.lineJoin = 'round';
        g.lineCap = 'butt';
        COPIAS.forEach(function (m) {
          g.beginPath();
          for (var i = 0; i <= 40; i++) {
            var p = punto(xa, ya, i / 40);
            if (i) { g.lineTo((p[0] + m * ancho) * esc, p[1] * esc); }
            else { g.moveTo((p[0] + m * ancho) * esc, p[1] * esc); }
          }
          g.stroke();
        });
        for (var b = 0; b < LUCES.bombillas.length; b++) {
          var q = punto(xa, ya, LUCES.bombillas[b]), color = bombillas[k % bombillas.length];
          k++;
          COPIAS.forEach(function (m) { bombilla(g, q[0] + m * ancho, q[1], color, esc); });
        }
      }
    }
  }

  function copo(g, x, y, r, giro, grosor, esc) {
    g.lineCap = 'butt';
    for (var k = 0; k < 3; k++) {
      var a = giro + k * Math.PI / 3, dx = r * Math.cos(a), dy = r * Math.sin(a);
      g.lineWidth = grosor * esc;
      g.beginPath();
      g.moveTo((x - dx) * esc, (y - dy) * esc);
      g.lineTo((x + dx) * esc, (y + dy) * esc);
      g.stroke();
      g.lineWidth = grosor * 0.8 * esc;
      for (var s = -1; s <= 1; s += 2) {
        var bx = x + s * dx * 0.6, by = y + s * dy * 0.6;
        for (var t = -1; t <= 1; t += 2) {
          var c = a + t * Math.PI / 4;
          g.beginPath();
          g.moveTo(bx * esc, by * esc);
          g.lineTo((bx + s * 0.35 * r * Math.cos(c)) * esc, (by + s * 0.35 * r * Math.sin(c)) * esc);
          g.stroke();
        }
      }
    }
  }

  /* Copos al tresbolillo en una tesela de ancho/4: cierra en la costura. Las
     posiciones salen de sacude(), igual que en Python. colores: fondo, copo. */
  function nieveFondo(g, colores, esc, ancho, alto, y0) {
    var tw = ancho / 4, th = NIEVE.alto;
    g.fillStyle = colores[1];
    g.strokeStyle = colores[1];
    for (var fila = 0, ty = y0; ty < alto; ty += th, fila++) {
      for (var n = 0; n < NIEVE.copos; n++) {
        var u = sacude(n, 1, 7), v = sacude(n, 2, 7), giro = sacude(n, 3, 7) * Math.PI;
        var tipo = n % 3, r = [4.2, 2.4, 0.9][tipo], y = ty + v * th;
        if (y - r < y0 || y > alto) { continue; }
        for (var tx = -1; tx < 5; tx++) {
          var x = tx * tw + u * tw + (fila % 2 ? tw / 2 : 0);
          if (tipo === 2) {
            g.beginPath();
            g.arc(x * esc, y * esc, r * esc, 0, Math.PI * 2);
            g.fill();
          } else {
            copo(g, x, y, r, giro, tipo === 0 ? 0.9 : 0.7, esc);
          }
        }
      }
    }
  }

  /* El baston de caramelo a 45 grados: en cada paso una banda y dos hilos. */
  var CARAMELO = { bandas: [[0.0, 6.0], [8.0, 1.2], [11.2, 1.2]] };
  function carameloFondo(g, colores, esc, ancho, alto, y0) {
    var paso = ancho / 12, largo = alto - y0;
    g.fillStyle = colores[1];
    for (var k = -Math.floor(largo / paso) - 2; k < Math.floor(ancho / paso) + 2; k++) {
      for (var b = 0; b < CARAMELO.bandas.length; b++) {
        var xa = k * paso + CARAMELO.bandas[b][0], an = CARAMELO.bandas[b][1];
        COPIAS.forEach(function (m) {
          var dx = m * ancho;
          g.beginPath();
          g.moveTo((xa + dx) * esc, y0 * esc);
          g.lineTo((xa + an + dx) * esc, y0 * esc);
          g.lineTo((xa + an + largo + dx) * esc, alto * esc);
          g.lineTo((xa + largo + dx) * esc, alto * esc);
          g.closePath();
          g.fill();
        });
      }
    }
  }

  /* Papel de regalo: filas de estrellas (colores[2]) y de topitos (colores[1]). */
  function estrellaFondo(g, cx, cy, r, esc) {
    g.beginPath();
    for (var i = 0; i < 10; i++) {
      var a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? r * 0.45 : r;
      var px = (cx + rr * Math.cos(a)) * esc, py = (cy + rr * Math.sin(a)) * esc;
      if (i) { g.lineTo(px, py); } else { g.moveTo(px, py); }
    }
    g.closePath();
    g.fill();
  }
  function regaloFondo(g, colores, esc, ancho, alto, y0) {
    var paso = ancho / 8;
    for (var f = 0, y = y0 + paso / 2; y < alto; y += paso / 2, f++) {
      for (var x = (paso / 2) * (f % 2); x < ancho + paso; x += paso) {
        COPIAS.forEach(function (m) {
          var cx = x + m * ancho;
          if (f % 2 === 0) {
            g.fillStyle = colores[2];
            estrellaFondo(g, cx, y, 4.0, esc);
          } else {
            g.fillStyle = colores[1];
            g.beginPath();
            g.arc(cx * esc, y * esc, 1.6 * esc, 0, Math.PI * 2);
            g.fill();
          }
        });
      }
    }
  }

  /* fondo_patron() de componer.py, pieza por pieza. Bajo todo lo demas y desde
     el fin del puno, que se queda limpio.

     LOS NUMEROS NO SE TOCAN. 21,475 · 32,2125 · 64,425 son el ancho de lamina
     (257,7) dividido por 12, 8 y 4: la trama cierra en la costura porque cabe un
     numero entero de veces. Redondearlos deja un salto visible en el canto.

     Cada pieza se pinta TRES veces -en x, x-ancho y x+ancho- porque el dibujo da
     la vuelta al tubo y lo que sale por un canto entra por el otro. Es lo mismo
     que hace pegar() con los elementos. */
  function patronFondo(g, cfg, tipo, colores, esc, ancho, alto) {
    if (!tipo || !colores || !colores.length) { return; }
    var y0 = (cfg.puno_mm || [0, 20])[1];
    function col(i) { return colores[((i % colores.length) + colores.length) % colores.length]; }

    if (tipo === 'bandas') {
      var altoB = 48.0, i = 0, y = y0;
      while (y < alto) {
        g.fillStyle = col(i);
        g.fillRect(0, y * esc, ancho * esc, (Math.min(alto, y + altoB) - y) * esc);
        y += altoB; i++;
      }
    } else if (tipo === 'verticales') {
      var an = 21.475, j = 0, x = 0;
      while (x < ancho) {
        g.fillStyle = col(j);
        g.fillRect(x * esc, y0 * esc, an * esc, (alto - y0) * esc);
        x += an; j++;
      }
    } else if (tipo === 'topos') {
      var paso = 32.2125, r = paso * 0.17, f = 0, yt = y0 + paso / 2;
      g.fillStyle = col(1);
      while (yt < alto) {
        var xt = (paso / 2) * (f % 2);
        while (xt < ancho + paso) {
          for (var k = -1; k <= 1; k++) {
            g.beginPath();
            g.arc((xt + k * ancho) * esc, yt * esc, r * esc, 0, Math.PI * 2);
            g.fill();
          }
          xt += paso;
        }
        yt += paso; f++;
      }
    } else if (tipo === 'rombos') {
      var lado = 64.425, altoR = lado * 1.45, fr = 0, yr = y0;
      while (yr < alto) {
        var xr = (lado / 2) * (fr % 2);
        while (xr < ancho + lado) {
          for (var m = -1; m <= 1; m++) {
            var cx = xr + m * ancho;
            g.fillStyle = col(fr + Math.floor(xr / lado));
            g.beginPath();
            g.moveTo(cx * esc, (yr + altoR / 2) * esc);
            g.lineTo((cx + lado / 2) * esc, yr * esc);
            g.lineTo((cx + lado) * esc, (yr + altoR / 2) * esc);
            g.lineTo((cx + lado / 2) * esc, (yr + altoR) * esc);
            g.closePath();
            g.fill();
          }
          xr += lado;
        }
        yr += altoR / 2; fr++;
      }
    } else if (tipo === 'luces') {
      lucesFondo(g, colores, esc, ancho, alto, y0);
    } else if (tipo === 'nieve') {
      nieveFondo(g, colores, esc, ancho, alto, y0);
    } else if (tipo === 'caramelo') {
      carameloFondo(g, colores, esc, ancho, alto, y0);
    } else if (tipo === 'regalo') {
      regaloFondo(g, colores, esc, ancho, alto, y0);
    } else if (tipo === 'partido') {
      g.fillStyle = col(1);
      g.fillRect(0, 220 * esc, ancho * esc, (alto - 220) * esc);
    }
  }

  /* franja_deportiva(): puño limpio y franja de 20 a 40 mm, con 2 mm de hueco. */
  function franja(g, cfg, colores, esc, ancho) {
    if (!cfg.franja || !cfg.franja_mm || !colores || !colores.length) { return; }
    var y0 = cfg.franja_mm[0], y1 = cfg.franja_mm[1], n = colores.length;
    if (n === 1) {
      g.fillStyle = colores[0];
      g.fillRect(0, y0 * esc, ancho * esc, (y1 - y0) * esc);
      return;
    }
    var alto = ((y1 - y0) - HUECO_FRANJA_MM * (n - 1)) / n, y = y0;
    for (var i = 0; i < n; i++) {
      g.fillStyle = colores[i];
      g.fillRect(0, y * esc, ancho * esc, alto * esc);
      y += alto + HUECO_FRANJA_MM;
    }
  }

  /* G-bandas: franjas a lo ancho del contorno, bajo todo lo demás, desde el fin
     del puño para que el puño se quede limpio como en las otras.
     Alternan el COLOR ELEGIDO y el acento de su paleta -la primera de la
     franja-. Antes rotaban los tres de la franja (verde, blanco, verde): dos
     verdes seguidos y el color elegido solo en el puño, que es lo que Carlos
     vio como «no funcionan bien los colores». Mismo criterio en componer.py. */
  function coloresBandas(fondo, franja) {
    var acento = (franja || []).filter(function (c) {
      return c && c.toUpperCase() !== String(fondo).toUpperCase();
    })[0] || '#FFFFFF';
    return [fondo, acento];
  }
  function bandas(g, cfg, fondo, franja, esc, ancho, alto) {
    if (!cfg.bandas) { return; }
    var colores = coloresBandas(fondo, franja);
    var y = cfg.puno_mm ? cfg.puno_mm[1] : 20, i = 0;
    while (y < alto) {
      g.fillStyle = colores[i % colores.length];
      g.fillRect(0, y * esc, ancho * esc, Math.min(alto - y, cfg.bandas) * esc);
      y += cfg.bandas; i++;
    }
  }

  /* K-medalla: el disco detrás de la cara, con el filete de icono. */
  function disco(mm, color, fileteMM, esc) {
    var d = Math.round(mm * esc);
    var c = document.createElement('canvas');
    c.width = d; c.height = d;
    var g = c.getContext('2d');
    g.fillStyle = color || '#FFFFFF';
    g.beginPath(); g.arc(d / 2, d / 2, d / 2 - 0.5, 0, Math.PI * 2); g.fill();
    return conFilete(c, fileteMM, esc);
  }

  function listaCaras(o) {
    if (o.caras && o.caras.length) { return o.caras.filter(function (c) { return c && c.width; }); }
    return (o.cara && o.cara.width) ? [o.cara] : [];
  }

  /* Las caras con su gorro al lado: o.gorros va en paralelo a o.caras, con
     { img, tipo, geo } o null. */
  function listaPiezas(o) {
    var out = [];
    (o.caras && o.caras.length ? o.caras : (o.cara ? [o.cara] : [])).forEach(function (c, i) {
      if (c && c.width) { out.push({ im: c, gz: (o.gorros && o.gorros[i]) || null }); }
    });
    return out;
  }
  /* La cabeza con el gorro entero puesto: el eco y el mosaico la usan así,
     sin hueco que respetar. Como en componer.py. */
  function conSuGorro(p) { return p.gz ? ponerGorro(p.im, p.gz).img : p.im; }

  /* montar_mash(): las caras SON el fondo. Sin filete, sin realce, sin
     desorden: cada ranura trae su escala y su giro desde plantillas.py. */
  function laminaMash(g, cv, cfg, o, esc, ancho) {
    g.fillStyle = FONDO_MASH;
    g.fillRect(0, 0, cv.width, cv.height);
    var caras = listaPiezas(o).map(conSuGorro);
    if (!caras.length) { return; }
    var cw = cfg.cara_mm[0], ch = cfg.cara_mm[1], cache = {};
    for (var n = 0; n < cfg.r.length; n++) {
      var r = cfg.r[n], k = (r[3] + r[4]) % caras.length, e = r[5] || 1, giro = r[6] || 0;
      if (k < 0) { k += caras.length; }
      var clave = k + ':' + e;
      if (!cache[clave]) { cache[clave] = vestir(caras[k], cw * e, ch * e, 0, esc); }
      tesela(g, cache[clave], r[1], r[2], esc, ancho, giro);
    }
  }

  /* La lámina entera, tal cual va a imprenta.
     NO se pintan talón ni puntera: la lámina va A SANGRE y ese negro viene
     TEJIDO en el calcetín. Lo del calcetín lo pone nerdis-forma.js.

     Orden de pintado, como el motor: fondo, bandas, franja, elementos y las
     CARAS las últimas, porque son el producto y no las tapa nada. */
  function lamina(cv, o) {
    ultimo = { cv: cv, o: o };
    var cfg = o.cfg, esc = o.escala || 3.0;
    var familia = o.fuente || cfg.fuente || 'Titan One';
    var ancho = cfg.lienzo_mm[0], alto = cfg.lienzo_mm[1];
    cv.width = Math.round(ancho * esc);
    cv.height = Math.round(alto * esc);
    var g = cv.getContext('2d');
    g.imageSmoothingQuality = 'high';

    if (cfg.mash) { return laminaMash(g, cv, cfg, o, esc, ancho); }

    g.fillStyle = o.fondo;
    g.fillRect(0, 0, cv.width, cv.height);
    // el patron va entre el color liso y las bandas, el mismo sitio que en
    // componer.py: `if patron: fondo_patron(...)` justo antes de `cfg["bandas"]`
    if (o.patron && o.patron.length > 1) {
      patronFondo(g, cfg, o.patron[0], o.patron.slice(1), esc, ancho, alto);
    }
    bandas(g, cfg, o.fondo, o.franja, esc, ancho, alto);
    // LA FRANJA VA AL FINAL, después de las caras, como en componer.montar()
    // (franja_deportiva después de pegar las caras). Hasta el 8 oct 2026 iba
    // aquí, antes de todo: daba igual porque nada llegaba al puño, pero el
    // gorro de la primera fila se queda a ras, y en un motor quedaba encima de
    // las rayas y en el otro debajo.

    var cw = cfg.cara_mm[0], ch = cfg.cara_mm[1];
    var ew = (cfg.elemento_mm || [46, 46])[0], eh = (cfg.elemento_mm || [46, 46])[1];
    var lw = (cfg.lettering_mm || [ew, eh])[0], lh = (cfg.lettering_mm || [ew, eh])[1];
    var giroBase = cfg.giro_elemento || 0;

    /* Las piezas de la ranura de cara: TEXTO en la plantilla de nombre, FOTOS
       en las demás -una por persona-. El texto lleva filete de icono -1,6-
       porque ya trae su contorno negro; la cara, 0,8: con más grueso el blanco
       puentea entre mechón y mechón y una melena rizada se hace una mancha. */
    /* ESPEJO ALTERNO (componer.espejo_alterno): POR FILA, y el eco al revés
       que la grande de su fila. No por (col + fila): en la tira que se ve de
       frente esa suma es siempre par o siempre impar y no alternaba nada.
       Cada pieza se prepara en las dos orientaciones y se refleja ANTES de
       vestirla, como en Python. Carlos, 25 sep 2026. */
    function espejoAlterno(r, eco) { return ((r[4] || 0) + (eco ? 1 : 0)) % 2 === 1; }
    var piezas = [], piezasEsp = [];
    if (cfg.texto) {
      if (o.texto) { piezas = [vestir(piezaTexto(o.texto, o.colorTexto, familia), cw, ch, o.fileteMM, esc)]; }
    } else {
      var fc = (o.fileteCaraMM === undefined ? 0.8 : o.fileteCaraMM);
      /* CON GORRO: se encaja la caja de la CABEZA crecida la mitad de lo que
         añade el gorro (GORRO.CUENTA) y la pieza se corre al pegarla para que
         esa caja quede en el centro del hueco. Como en componer.montar(). */
      var piezaCara = function (p, esp) {
        var im = esp ? espejo(p.im) : p.im;
        var k = realceCara(im);
        if (!p.gz) { return vestir(im, cw * k, ch * k, fc, esc); }
        var cg = ponerGorro(p.im, p.gz);
        var W0 = p.im.width, H0 = p.im.height;
        var u = esp ? [W0 - cg.u[2], cg.u[1], W0 - cg.u[0], cg.u[3]] : cg.u;
        var ef = cajaEfectiva(W0, H0, u);
        var f = Math.min(cw * k * esc / (ef[2] - ef[0]), ch * k * esc / (ef[3] - ef[1]));
        var src = esp ? espejo(cg.img) : cg.img;
        var c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(src.width * f));
        c.height = Math.max(1, Math.round(src.height * f));
        var gc = c.getContext('2d');
        gc.imageSmoothingQuality = 'high';
        gc.drawImage(src, 0, 0, c.width, c.height);
        var pieza = conFilete(c, fc, esc);
        pieza.gorro = { u: u, ef: ef, f: f };
        return pieza;
      };
      var lista = listaPiezas(o);
      piezas = lista.map(function (p) { return piezaCara(p, false); });
      piezasEsp = lista.map(function (p) { return piezaCara(p, true); });
    }

    /* F-nombre-y-cara: el nombre va en uno de cada dos huecos de icono, con
       la caja de lettering, y nunca sobre el talón ni la puntera: ahí el hilo
       es negro y la frase se parte justo cuando es la que hay que leer. */
    var nombre = (cfg.lettering_texto && o.texto)
      ? vestir(piezaTexto(o.texto, o.colorTexto, familia), lw, lh, o.fileteMM, esc)
      : null;

    /* LA FRASE DEL TEMA -FELIZ NAVIDAD, MODO ELFO- es una IMAGEN y la trae el
       tema, no el cliente. Va en la caja de lettering, que es más ancha que la
       de icono, y solo donde no la parta el hilo negro. */
    var frase = o.frase ? vestir(o.frase, lw, lh, o.fileteMM, esc) : null;
    var orden = ordenElementos(cfg, ancho), conFrase = orden.conFrase;

    /* La pieza de trama (la huella) va SIN FILETE, teñida y a 0,55 de la caja
       del icono, como textura=... en componer.montar(). */
    var elems = [];
    if (o.sprite) {
      var tramada = TRAMA[juegoDe(o)];
      for (var i = 0; i < o.marcos; i++) {
        elems.push(i === tramada
          ? vestir(tenir(marco(o.sprite, i), colorTrama(o.fondo, o.colorTexto)),
                   ew * TRAMA_ESCALA, eh * TRAMA_ESCALA, 0, esc)
          : vestir(marco(o.sprite, i), ew, eh, o.fileteMM, esc));
      }
    }
    var medalla = cfg.marco ? disco(cfg.marco, o.colorMarco, o.fileteMM, esc) : null;

    /* ECO (la ficha generica "Con Foto", nerdis.iconos = eco): en las ranuras
       de icono no va un dibujo, va la PROPIA cara, reflejada una de cada dos y girando como
       las demás piezas. Copiado de componer.py (eco=True): la persona de su
       FILA, el filete de cara y sin realce. Si se cambia aqui, se cambia alli.
       EL ECO ES PEQUEÑO SIEMPRE (ECO_PEQUENO de la caja del icono), con una
       cara o con varias: del 25 al 30 sep, con varias iba a la caja de cara y
       el calcetín quedaba en cuadrícula recta. Ver la nota en componer.py. */
    var ecos = [], ecosEsp = [];
    if (o.eco && !cfg.texto) {
      var fe = (o.fileteCaraMM === undefined ? 0.8 : o.fileteCaraMM);
      var aEco = function (im) { return vestir(im, ew * ECO_PEQUENO, eh * ECO_PEQUENO, fe, esc); };
      ecos = listaPiezas(o).map(function (p) { return aEco(conSuGorro(p)); });
      ecosEsp = listaPiezas(o).map(function (p) { return aEco(espejo(conSuGorro(p))); });
    }

    var caras = [];
    for (var n = 0; n < cfg.r.length; n++) {
      var r = cfg.r[n], rx = r[1], ry = r[2];
      if (r[0] !== 'c') { continue; }
      var sc = sacudida(cfg, r, 'cara');
      if (medalla) { tesela(g, medalla, rx + sc[0], ry + sc[1], esc, ancho, 0); }
      if (piezas.length) {
        var k = persona(r, piezas.length);
        caras.push([rx + sc[0], ry + sc[1], sc[2], k, !cfg.texto && espejoAlterno(r)]);
      }
    }
    /* Los elementos, EN ORDEN DE LECTURA (frente arriba-abajo, luego atrás),
       con el mismo índice iEl que `i` en componer.py y los iconos contados
       aparte, para que la frase y el nombre no se coman iconos del ciclo. */
    var kIcono = 0;
    for (var iEl = 0; iEl < orden.lista.length; iEl++) {
      var re = orden.lista[iEl], ex = re[1], ey = re[2];
      /* nombre, icono, nombre, icono; con «Solo caras», nombre en TODAS
         (Carlos, 25 sep 2026). Como texto_aqui en componer.montar(). */
      /* El nombre solo esquiva el talón de atrás; la puntera no, aunque le
         coma un trozo. Como texto_aqui en componer.montar(). */
      var conNombre = nombre && (cfg.filas_alternas || o.eco || iEl % 2 === 0) &&
                      !pisaNegro(ey, lh, ex, false);
      if (conNombre) {
        var sl = sacudida(cfg, re, cfg.filas_alternas ? 'elemento' : 'lettering');
        tesela(g, nombre, ex + sl[0], ey + sl[1], esc, ancho, giroBase + sl[2]);
      } else if (frase && conFrase[iEl]) {
        var sf = sacudida(cfg, re, 'lettering');
        tesela(g, frase, ex + sf[0], ey + sf[1], esc, ancho, giroBase + sf[2]);
      } else if (ecos.length) {
        var so = sacudida(cfg, re, 'elemento');
        var ke = persona(re, ecos.length);
        /* Los 11 grados propios del eco solo si la plantilla no gira ya alterno
           los elementos: sumados a los 12 del alterno, media fila salía a 23 y
           la otra a 1. Carlos, 25 sep 2026: todas giran igual. */
        var giroEco = ((cfg.giro_alterno || []).indexOf('elemento') >= 0) ? 0
                    : (iEl % 2 === 0 ? 11 : -11);
        tesela(g, (espejoAlterno(re, true) ? ecosEsp : ecos)[ke], ex + so[0], ey + so[1], esc, ancho, giroBase + so[2] + giroEco);
      } else if (elems.length && !o.eco) {
        /* Con eco y SIN caras (antes de subir la foto) el hueco se queda vacío:
           «Solo caras» enseñaba los dibujos de siempre y solo quitaba la frase
           (Carlos, 14 oct 2026). componer.py, con eco, nunca pone un icono. */
        var se = sacudida(cfg, re, 'elemento');
        tesela(g, elems[kIcono % elems.length], ex + se[0], ey + se[1], esc, ancho, giroBase + se[2]);
        kIcono++;
      }
    }
    for (var m = 0; m < caras.length; m++) {
      var pz = (caras[m][4] ? piezasEsp : piezas)[caras[m][3]];
      var px = caras[m][0], py = caras[m][1];
      if (pz.gorro) {
        var dz = desplazamientoGorro(pz.gorro.u, pz.gorro.ef, pz.gorro.f, caras[m][2]);
        px += dz[0] / esc; py += dz[1] / esc;
      }
      tesela(g, pz, px, py, esc, ancho, caras[m][2]);
    }
    franja(g, cfg, o.franja, esc, ancho);

    /* El wordmark va APAGADO por defecto. Se quitó el 30/08/2026: en el calcetín
       roba sitio al nombre, que es el producto. Queda detrás de un interruptor
       y no borrado, para que volver a ponerlo sea pasar wordmark:true. */
    if (cfg.nerdis_y_mm && o.wordmark) {
      g.save();
      g.font = Math.round(13 * esc) + 'px ' + familiaCss('Titan One');
      g.textAlign = 'center';
      g.textBaseline = 'middle';
      g.fillStyle = o.colorLogo || (o.franja && o.franja[0]) || '#FFFFFF';
      g.fillText('NERDIS', ancho / 2 * esc, cfg.nerdis_y_mm * esc);
      g.restore();
    }
  }

  /* La tipografía web llega tarde. Si se dibuja antes, el navegador mide con la
     de reserva y el nombre sale con otro tamaño del que se va a imprimir. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      if (ultimo && ultimo.o && ultimo.o.repintar) { ultimo.o.repintar(); }
    });
  }

  window.NERDIS.dibujo = { lamina: lamina, piezaTexto: piezaTexto, ordenElementos: ordenElementos,
                           conFilete: conFilete, vestir: vestir,
                           realceCara: realceCara, sacude: sacude, sacudida: sacudida,
                           pisaNegro: pisaNegro, persona: persona, ECO_PEQUENO: ECO_PEQUENO,
                           colorTrama: colorTrama,
                           TRAMA: TRAMA,
                           GORRO: GORRO, colocacionGorro: colocacionGorro,
                           geometriaGorro: geometriaGorro, cajaEfectiva: cajaEfectiva,
                           desplazamientoGorro: desplazamientoGorro,
                           contornoAlfa: contornoAlfa, ponerGorro: ponerGorro };
})();